import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayIfNotZero',
})
export class DisplayIfNotZeroPipe implements PipeTransform {
  transform(value: number): any {
    return value !== 0 ? value : '';
  }
}
